export default "__VITE_ASSET__DeuatIOh__"